import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Logo from './common/Logo';

const { FiMail, FiPhone } = FiIcons;

const Header = () => {
  return (
    <header className="bg-white shadow-sm border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <Logo className="h-12 w-auto" color="black" />
          </div>
          
          <div className="text-right">
            <h3 className="text-lg font-semibold text-black">Creatica Studio Inc.</h3>
            <p className="text-sm text-gray-600">14-6 Curity Ave</p>
            <p className="text-sm text-gray-600">Toronto, ON M4B 3L8</p>
            <div className="flex items-center justify-end space-x-4 mt-2">
              <a 
                href="mailto:info@creati.ca" 
                className="flex items-center text-[#FF5F1F] hover:text-black transition-colors"
              >
                <SafeIcon icon={FiMail} className="w-4 h-4 mr-1" />
                <span className="text-sm">info@creati.ca</span>
              </a>
              <div className="flex items-center text-gray-600">
                <SafeIcon icon={FiPhone} className="w-4 h-4 mr-1" />
                <span className="text-sm">+1 416.731.1188</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;